function NXSetting({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4293_1297)">
        <path
          d="M0.821411 2.96433V21.0358C0.821411 21.9431 1.55694 22.6786 2.46427 22.6786H20.5357C21.443 22.6786 22.1786 21.9431 22.1786 21.0358V2.96433C22.1786 2.057 21.443 1.32147 20.5357 1.32147H2.46427C1.55694 1.32147 0.821411 2.057 0.821411 2.96433Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.39282 18.5715V10.3572"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.39281 10.3572C8.75381 10.3572 9.8571 9.2539 9.8571 7.8929C9.8571 6.53191 8.75381 5.42862 7.39281 5.42862C6.03182 5.42862 4.92853 6.53191 4.92853 7.8929C4.92853 9.2539 6.03182 10.3572 7.39281 10.3572Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6071 5.42862V10.3572"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6071 15.2858V18.5715"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6071 15.2857C16.9681 15.2857 18.0714 14.1825 18.0714 12.8215C18.0714 11.4605 16.9681 10.3572 15.6071 10.3572C14.2461 10.3572 13.1428 11.4605 13.1428 12.8215C13.1428 14.1825 14.2461 15.2857 15.6071 15.2857Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4293_1297">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500031)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXSetting;
